export enum CardsCollectionVariantEnum {
    CENTERED_PICTURE_BOTTOM = 'CenteredPictureBottom',
    LANDSCAPE_PICTURE_TOP = 'LandscapePictureTop',
}
